import { render, staticRenderFns } from "./HotsiteConfigurationColors.vue?vue&type=template&id=13e5ad13"
import script from "./HotsiteConfigurationColors.vue?vue&type=script&lang=js"
export * from "./HotsiteConfigurationColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports